export default "__VITE_ASSET__N$JD1$VJ__"